(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cj-home-shop"] && !Shopify.designMode) return;
  try {
    
(function(){
  function initCjhShop(section){
    if(section.dataset.cjhInit) return;
    section.dataset.cjhInit = '1';

    /* Tabs: ARIA tabs pattern with roving tabindex and arrow keys */
    var tabs = Array.prototype.slice.call(section.querySelectorAll('[data-cjh-tab]'));
    var panels = section.querySelectorAll('[data-cjh-panel]');
    var selectTab = function(tab, focus){
      var idx = tab.getAttribute('data-cjh-tab');
      tabs.forEach(function(t){
        var on = t === tab;
        t.setAttribute('aria-selected', on ? 'true' : 'false');
        t.setAttribute('tabindex', on ? '0' : '-1');
      });
      panels.forEach(function(p){
        if(p.getAttribute('data-cjh-panel') === idx){ p.removeAttribute('hidden'); }
        else { p.setAttribute('hidden', ''); }
      });
      if(focus){ tab.focus(); }
    };
    tabs.forEach(function(tab, i){
      tab.setAttribute('tabindex', tab.getAttribute('aria-selected') === 'true' ? '0' : '-1');
      tab.addEventListener('click', function(){ selectTab(tab, false); });
      tab.addEventListener('keydown', function(e){
        var n = null;
        if(e.key === 'ArrowRight'){ n = (i + 1) % tabs.length; }
        else if(e.key === 'ArrowLeft'){ n = (i - 1 + tabs.length) % tabs.length; }
        else if(e.key === 'Home'){ n = 0; }
        else if(e.key === 'End'){ n = tabs.length - 1; }
        if(n !== null){ e.preventDefault(); selectTab(tabs[n], true); }
      });
    });

    /* Toast: persistent polite status region (announced by screen readers) */
    var toast = section.querySelector('[data-cjh-toast]');
    var showToast = function(msg){
      if(!toast) return;
      toast.textContent = msg;
      toast.classList.add('cjh-toast--show');
      clearTimeout(toast._t);
      toast._t = setTimeout(function(){ toast.classList.remove('cjh-toast--show'); toast.textContent = ''; }, 2200);
    };

    /* Quick add: progressive enhancement over a native cart form POST.
       Success dispatches ajaxProduct:added ONCE (bubbles to document), which
       this theme's cart drawer and UpCart both react to. HTTP errors show an
       inline message; only a network-level failure falls back to native POST
       (nothing was added in that case, so no double-add is possible). */
    section.querySelectorAll('form[data-cjh-add]').forEach(function(form){
      var dataEl = form.querySelector('[data-cjh-variants]');
      var variants = null;
      try { variants = dataEl ? JSON.parse(dataEl.textContent) : null; } catch(err) { variants = null; }
      var idInput = form.querySelector('input[name="id"]');
      var addBtn = form.querySelector('button[type=submit]');
      var resolveVariant = function(){
        if(!variants || !idInput) return;
        var sels = form.querySelectorAll('[data-cjh-opt]');
        if(!sels.length) return;
        var o1 = sels[0].value;
        var o2 = sels.length > 1 ? sels[1].value : null;
        var match = null;
        for(var i = 0; i < variants.length; i++){
          if(variants[i].o1 === o1 && (o2 === null || variants[i].o2 === o2)){ match = variants[i]; break; }
        }
        if(match && match.a){
          idInput.value = match.id;
          if(addBtn){ addBtn.disabled = false; addBtn.textContent = 'Add to cart'; }
        } else if(addBtn){
          addBtn.disabled = true; addBtn.textContent = match ? 'Sold out' : 'Unavailable';
        }
      };
      form.querySelectorAll('[data-cjh-opt]').forEach(function(sel){ sel.addEventListener('change', resolveVariant); });
      resolveVariant();

      form.addEventListener('submit', function(e){
        if(!window.fetch) return;
        e.preventDefault();
        var btn = form.querySelector('button[type=submit]');
        var label = btn ? btn.textContent : '';
        if(btn){ btn.disabled = true; btn.textContent = 'Adding...'; }
        var settle = function(text){
          if(!btn) return;
          btn.disabled = false; btn.textContent = text;
          setTimeout(function(){ btn.textContent = label || 'Add to cart'; }, 2200);
        };
        fetch(form.action + '.js', {
          method: 'POST',
          headers: { 'X-Requested-With': 'XMLHttpRequest', 'Accept': 'application/json' },
          body: new FormData(form)
        })
        .then(function(r){
          return r.json().catch(function(){ return null; }).then(function(data){ return { ok: r.ok, data: data }; });
        })
        .then(function(res){
          if(!res.ok){
            settle('Try again');
            showToast(res.data && res.data.description ? res.data.description : 'Could not add to cart. Please try again.');
            return;
          }
          try {
            settle('Added');
            form.dispatchEvent(new CustomEvent('ajaxProduct:added', {
              detail: { product: res.data, addToCartBtn: btn }, bubbles: true
            }));
            if(!document.querySelector('#CartDrawer, [data-section-type="cart-drawer"]')){ showToast('Added to cart'); }
          } catch(err) { /* the item is already in the cart; never re-submit */ }
        })
        .catch(function(){ form.submit(); });
      });
    });
  }
  document.querySelectorAll('[data-cjh-scope]').forEach(initCjhShop);
  document.addEventListener('shopify:section:load', function(e){
    var el = e.target && e.target.querySelector ? e.target.querySelector('[data-cjh-scope]') : null;
    if(el) initCjhShop(el);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cj-home-trust"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var API = 'https://api.okendo.io/v1/stores/';

    function esc(s) {
      return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
        return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
      });
    }

    function stars(n) {
      n = Math.max(0, Math.min(5, Math.round(Number(n) || 0)));
      var full = new Array(n + 1).join('★');
      var rest = new Array(6 - n).join('★');
      return '<span class="cjh-trust__st" aria-hidden="true">' + full +
             '<i>' + rest + '</i></span><span class="cjh-trust__sr">' + n + ' out of 5 stars</span>';
    }

    function card(r) {
      var body = String(r.body || '').replace(/\s+/g, ' ').trim();
      var who = (r.reviewer && (r.reviewer.displayName || r.reviewer.name)) || 'Verified buyer';
      var prod = String(r.productName || '').trim();
      var title = String(r.title || '').replace(/\s+/g, ' ').trim();
      var showTitle = title && !/^\d\s*stars?$/i.test(title);
      var purl = String(r.productUrl || '');
      if (purl.indexOf('//') === 0) purl = 'https:' + purl;
      var pimg = String(r.productImageUrl || '');
      if (pimg) pimg += (pimg.indexOf('?') === -1 ? '?' : '&') + 'width=120';
      var foot;
      if (prod && purl) {
        foot = '<a class="cjh-trust__prod" href="' + esc(purl) + '">' +
          (pimg ? '<img src="' + esc(pimg) + '" alt="" loading="lazy" width="40" height="40">' : '') +
          '<span>' + esc(prod) + '</span></a>';
      } else {
        foot = '<span class="cjh-trust__prod cjh-trust__prod--nolink">' +
          (prod ? esc(prod) : 'Verified buyer') + '</span>';
      }
      return '<li class="cjh-trust__rv">' + stars(r.rating) +
        (showTitle ? '<h3>' + esc(title) + '</h3>' : '') +
        '<p>' + esc(body) + '</p>' +
        '<footer><b>' + esc(who) + '</b>' + foot + '</footer></li>';
    }

    function init(root) {
      var sub = root.getAttribute('data-subscriber');
      if (!sub) return;
      var minRating = Number(root.getAttribute('data-min-rating')) || 4;
      var minWords = Number(root.getAttribute('data-min-words')) || 12;
      var maxChars = Number(root.getAttribute('data-max-chars')) || 340;
      var want = Number(root.getAttribute('data-limit')) || 12;
      var match = (root.getAttribute('data-match') || '').toLowerCase().trim();
      var excl = (root.getAttribute('data-exclude') || '').toLowerCase().trim();
      var maxPer = Number(root.getAttribute('data-max-per-product')) || 2;
      var hide = (root.getAttribute('data-hide') || '').toLowerCase().trim();
      var dwell = (Number(root.getAttribute('data-dwell')) || 5) * 1000;
      var split = function (v) {
        return v ? v.split(',').map(function (t) { return t.trim(); }).filter(Boolean) : [];
      };
      var terms = split(match), exTerms = split(excl), hideTerms = split(hide), perProduct = {};

      var keep = [];
      var pages = 0;

      function ok(r) {
        if ((Number(r.rating) || 0) < minRating) return false;
        var b = String(r.body || '').replace(/\s+/g, ' ').trim();
        if (!b || b.length > maxChars) return false;
        if (b.split(' ').length < minWords) return false;
        if (r.isIncentivized) return false;
        // a complaint can carry five stars: block on the words, whatever the rating
        var text = (String(r.title || '') + ' ' + b).toLowerCase();
        if (hideTerms.length && hideTerms.some(function (t) { return text.indexOf(t) !== -1; })) return false;
        var hay = ((r.productName || '') + ' ' + (r.productHandle || '')).toLowerCase();
        // exclude wins over include: a DayBasics review must never appear here
        if (exTerms.length && exTerms.some(function (t) { return hay.indexOf(t) !== -1; })) return false;
        if (terms.length && !terms.some(function (t) { return hay.indexOf(t) !== -1; })) return false;
        // one product dominates the review set, so cap how many of it can show
        var key = r.productName || '?';
        if ((perProduct[key] || 0) >= maxPer) return false;
        perProduct[key] = (perProduct[key] || 0) + 1;
        return true;
      }

      function render() {
        if (keep.length < 3) return;
        var picked = keep.slice(0, want);
        var track = root.querySelector('[data-cjh-rv-track]');
        var viewport = root.querySelector('[data-cjh-rv-viewport]');
        if (!track || !viewport) return;
        // duplicate the set so stepping past the end always has cards to show
        track.innerHTML = picked.map(card).join('') + picked.map(card).join('');
        root.hidden = false;
        var note = document.querySelector('[data-cjh-rv-note]');
        if (note) note.hidden = true;
        start(track, viewport, picked.length);
      }

      function start(track, viewport, count) {
        var reduce = window.matchMedia &&
          window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        if (reduce) { viewport.style.overflowX = 'auto'; return; }

        var i = 0, timer = null, paused = false;
        function step(px) {
          var first = track.children[0];
          if (!first) return 0;
          var gap = parseFloat(getComputedStyle(track).columnGap || '20') || 20;
          return first.getBoundingClientRect().width + gap;
        }
        function place(instant) {
          if (instant) track.classList.add('is-instant');
          track.style.transform = 'translateX(' + (-step() * i) + 'px)';
          if (instant) {
            void track.offsetWidth;               // force reflow so the class lift takes
            track.classList.remove('is-instant');
          }
        }
        function advance() {
          if (paused) return;
          i += 1;
          place(false);
          if (i >= count) {                       // snap back once the copy is showing
            window.setTimeout(function () { i = 0; place(true); }, dwell * 0.55);
          }
        }
        function run() {
          window.clearInterval(timer);
          timer = window.setInterval(advance, dwell);
        }
        // pauseOnMouseEnter, and resume after: same as the reference site
        viewport.addEventListener('mouseenter', function () { paused = true; });
        viewport.addEventListener('mouseleave', function () { paused = false; });
        viewport.addEventListener('focusin', function () { paused = true; });
        viewport.addEventListener('focusout', function () { paused = false; });
        document.addEventListener('visibilitychange', function () {
          if (document.hidden) { window.clearInterval(timer); } else { run(); }
        });
        window.addEventListener('resize', function () { place(true); });
        run();
      }

      function load(url) {
        fetch(url, { headers: { Accept: 'application/json' } })
          .then(function (res) { return res.ok ? res.json() : null; })
          .then(function (j) {
            if (!j) { render(); return; }
            (j.reviews || []).forEach(function (r) { if (ok(r)) keep.push(r); });
            pages += 1;
            var next = j.nextUrl;
            if (next && next.charAt(0) === '/') next = 'https://api.okendo.io/v1' + next;
            if (keep.length < want && next && pages < 6) { load(next); } else { render(); }
          })
          .catch(function () { render(); });
      }

      load(API + encodeURIComponent(sub) + '/reviews?limit=100');
    }

    function boot() {
      var nodes = document.querySelectorAll('[data-cjh-reviews]');
      for (var i = 0; i < nodes.length; i++) init(nodes[i]);
    }
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', boot);
    } else { boot(); }
    document.addEventListener('shopify:section:load', boot);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cj-nsl-grid"] && !Shopify.designMode) return;
  try {
    
(function() {
  if (!window.fetch) return;
  var jobs = {};

  function load(card) {
    var id = card.dataset.productId;
    var handle = card.dataset.productHandle;
    if (jobs[id]) return jobs[id];
    if (!window.theme || !theme.Modals || !theme.routes) return Promise.resolve(false);
    var url = (theme.routes.home + '/products/' + handle + '?view=modal').replace('//', '/');
    jobs[id] = fetch(url)
      .then(function(r) { return r.text(); })
      .then(function(text) {
        var html = document.createElement('div');
        html.innerHTML = text;
        var div = html.querySelector('.product-section[data-product-handle="' + handle + '"]');
        var holder = document.getElementById('QuickShopHolder-' + handle);
        if (!div || !holder) return false;
        holder.innerHTML = '';
        holder.append(div);
        new theme.Modals('QuickShopModal-' + id, 'quick-modal-' + id);
        theme.sections.register('product', theme.Product, holder);
        theme.collapsibles.init();
        var m = document.getElementById('QuickShopModal-' + id);
        if (m) m.dataset.nslReady = '1';
        return true;
      })
      .catch(function() { return false; });
    return jobs[id];
  }

  document.querySelectorAll('.nsl-card[data-product-handle]').forEach(function(card) {
    var warm = function() {
      card.removeEventListener('mouseover', warm);
      card.removeEventListener('focusin', warm);
      card.removeEventListener('touchstart', warm);
      load(card);
    };
    card.addEventListener('mouseover', warm);
    card.addEventListener('focusin', warm);
    card.addEventListener('touchstart', warm, { passive: true });

    var qv = card.querySelector('[data-nsl-qv]');
    if (!qv) return;
    qv.addEventListener('keydown', function(evt) {
      if (evt.key === 'Enter' || evt.key === ' ') {
        evt.preventDefault();
        qv.click();
      }
    });
    qv.addEventListener('click', function(evt) {
      evt.stopPropagation();
      var m = document.getElementById('QuickShopModal-' + card.dataset.productId);
      if (m && m.dataset.nslReady) return;
      evt.preventDefault();
      load(card).then(function(ok) {
        if (ok) {
          qv.click();
        } else {
          window.location.href = card.getAttribute('href');
        }
      });
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cj-ows-band"] && !Shopify.designMode) return;
  try {
    
(function() {
  if (!window.fetch) return;
  var jobs = {};

  function load(card) {
    var id = card.dataset.productId;
    var handle = card.dataset.productHandle;
    if (jobs[id]) return jobs[id];
    if (!window.theme || !theme.Modals || !theme.routes) return Promise.resolve(false);
    var url = (theme.routes.home + '/products/' + handle + '?view=modal').replace('//', '/');
    jobs[id] = fetch(url)
      .then(function(r) { return r.text(); })
      .then(function(text) {
        var html = document.createElement('div');
        html.innerHTML = text;
        var div = html.querySelector('.product-section[data-product-handle="' + handle + '"]');
        var holder = document.getElementById('QuickShopHolder-' + handle);
        if (!div || !holder) return false;
        holder.innerHTML = '';
        holder.append(div);
        new theme.Modals('QuickShopModal-' + id, 'quick-modal-' + id);
        theme.sections.register('product', theme.Product, holder);
        theme.collapsibles.init();
        var m = document.getElementById('QuickShopModal-' + id);
        if (m) m.dataset.owsReady = '1';
        return true;
      })
      .catch(function() { return false; });
    return jobs[id];
  }

  document.querySelectorAll('.ows__more[data-ows-more]').forEach(function(btn) {
    btn.addEventListener('click', function() {
      var sect = btn.closest('.ows__sect');
      if (!sect) return;
      var n = parseInt(btn.dataset.owsMore, 10) || 5;
      var hidden = [].slice.call(sect.querySelectorAll('.ows__card--more'));
      hidden.slice(0, n).forEach(function(card) { card.classList.remove('ows__card--more'); });
      if (hidden.length <= n) btn.parentNode.removeChild(btn);
      var first = hidden[0] && hidden[0].querySelector('.ows__ttl');
      if (first) first.focus({ preventScroll: true });
    });
  });

  document.querySelectorAll('.ows__card[data-product-handle]').forEach(function(card) {
    var warm = function() {
      card.removeEventListener('mouseover', warm);
      card.removeEventListener('focusin', warm);
      card.removeEventListener('touchstart', warm);
      load(card);
    };
    card.addEventListener('mouseover', warm);
    card.addEventListener('focusin', warm);
    card.addEventListener('touchstart', warm, { passive: true });

    [].slice.call(card.querySelectorAll('[data-ows-qv]')).forEach(function(trigger) {
      trigger.addEventListener('keydown', function(evt) {
        if (evt.key === 'Enter' || evt.key === ' ') {
          evt.preventDefault();
          trigger.click();
        }
      });
      trigger.addEventListener('click', function(evt) {
        evt.stopPropagation();
        var m = document.getElementById('QuickShopModal-' + card.dataset.productId);
        if (m && m.dataset.owsReady) return;
        evt.preventDefault();
        load(card).then(function(ok) {
          if (ok) {
            trigger.click();
          } else {
            var fallback = trigger.getAttribute('href') || (card.querySelector('.ows__ttl') || {}).href;
            if (fallback) window.location.href = fallback;
          }
        });
      });
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product-high-variant"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('product-form:cart:navigate', (event) => {
    theme.settings.cartType !== 'page' && event.preventDefault();
  });

  document.addEventListener('product-form:submit:success', () => {
    document.dispatchEvent(new CustomEvent('ajaxProduct:added'));
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["prime-the-cool"] && !Shopify.designMode) return;
  try {
    
(function(){
  var root = document.querySelector('[data-ptc-root]') || document;

  /* Countdown(s) to a fixed UTC instant */
  var cds = root.querySelectorAll('[data-ptc-countdown]');
  if(cds.length){
    var end = new Date(cds[0].getAttribute('data-endtime')).getTime();
    var tick = function(){
      var diff = end - Date.now();
      cds.forEach(function(cd){
        var clock = cd.querySelector('[data-ptc-clock]');
        if(!clock) return;
        if(isNaN(end)){ clock.textContent=''; return; }
        if(diff <= 0){ clock.textContent = 'Sale ended'; return; }
        var d=Math.floor(diff/864e5), h=Math.floor(diff%864e5/36e5), m=Math.floor(diff%36e5/6e4), sec=Math.floor(diff%6e4/1e3);
        var p=function(n){return (n<10?'0':'')+n;};
        clock.textContent = (d>0? d+'d ':'') + p(h)+':'+p(m)+':'+p(sec);
      });
      if(diff <= 0){
        root.querySelectorAll('[data-ptc-cta]').forEach(function(b){ b.textContent='Sale ended'; b.style.pointerEvents='none'; b.style.opacity='.6'; });
        return;
      }
      setTimeout(tick, 1000);
    };
    tick();
  }

  /* Tap-to-copy */
  var toast = root.querySelector('[data-ptc-toast]');
  var showToast = function(msg){ if(!toast) return; toast.textContent=msg; toast.hidden=false; clearTimeout(toast._t); toast._t=setTimeout(function(){toast.hidden=true;},1600); };
  root.querySelectorAll('[data-ptc-copy]').forEach(function(el){
    el.addEventListener('click', function(){
      var c = el.getAttribute('data-ptc-copy');
      var done = function(){ showToast(c + ' copied'); };
      if(navigator.clipboard && navigator.clipboard.writeText){ navigator.clipboard.writeText(c).then(done).catch(function(){ done(); }); }
      else { var t=document.createElement('textarea'); t.value=c; document.body.appendChild(t); t.select(); try{document.execCommand('copy');}catch(e){} document.body.removeChild(t); done(); }
    });
  });

  /* Open target <details> from in-page links */
  root.querySelectorAll('a[href^="#"]').forEach(function(a){
    a.addEventListener('click', function(){
      var el = document.getElementById(a.getAttribute('href').slice(1));
      if(el && el.tagName && el.tagName.toLowerCase()==='details'){ el.open = true; }
    });
  });

  /* Progressive-enhancement add to cart */
  root.querySelectorAll('form[data-ptc-add]').forEach(function(form){
    form.addEventListener('submit', function(e){
      if(!window.fetch) return;
      e.preventDefault();
      var btn = form.querySelector('button[type=submit]');
      var label = btn ? btn.textContent : '';
      if(btn){ btn.disabled=true; btn.textContent='Adding...'; }
      fetch(form.action + '.js', { method:'POST', headers:{'X-Requested-With':'XMLHttpRequest','Accept':'application/json'}, body:new FormData(form) })
        .then(function(r){ if(!r.ok) throw new Error('add failed'); return r.json(); })
        .then(function(){
          if(btn){ btn.textContent='Added âœ“'; btn.disabled=false; }
          showToast('Added to cart');
          document.dispatchEvent(new CustomEvent('cart:refresh', {bubbles:true}));
          document.dispatchEvent(new CustomEvent('cart:build', {bubbles:true}));
          setTimeout(function(){ if(btn){ btn.textContent=label||'Add to cart'; } }, 2000);
        })
        .catch(function(){ form.submit(); });
    });
  });

  /* Hide mobile sticky CTA while final CTA is on screen */
  var mob = root.querySelector('[data-ptc-mobilecta]');
  var fin = root.querySelector('.ptc-final');
  if(mob && fin && 'IntersectionObserver' in window){
    new IntersectionObserver(function(en){ mob.style.display = en[0].isIntersecting ? 'none' : ''; }, {threshold:.1}).observe(fin);
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["shoppable-hero"] && !Shopify.designMode) return;
  try {
    
  class KitShoppableHero extends HTMLElement {
    connectedCallback() {
      this.abortController = new AbortController();
      const signal = this.abortController.signal;

      if (window.theme && window.theme.sections) {
        this.initQuickShop();
      } else {
        document.addEventListener('page:loaded', () => this.initQuickShop(), { once: true, signal });
      }

      if (this.querySelector('kit-popover')) {
        window.addEventListener('scroll', () => {
          this.querySelectorAll('kit-popover:popover-open').forEach(p => p.hidePopover());
        }, { passive: true, signal });
      }

      if (!Shopify.designMode) return;

      document.addEventListener('shopify:section:load', (event) => {
        if (event.target.contains(this)) {
          this.initQuickShop();
        }
      }, { signal });

      this.addEventListener('shopify:block:select', (event) => {
        this.initQuickShop();
        const btn = event.target.querySelector('button');
        if (btn) btn.click();
      }, { signal });

      this.addEventListener('shopify:block:deselect', (event) => {
        const popover = event.target.querySelector('kit-popover');
        if (popover) popover.hidePopover?.();
      }, { signal });
    }

    disconnectedCallback() {
      this.abortController?.abort();
    }

    initQuickShop() {
      if (!theme.settings.quickView) return;

      var sectionEl = this.closest('[id^="shopify-section-"]');
      var links = this.querySelectorAll('.shoppable-hero__popover-link[data-product-handle]');
      if (!links.length) return;

      links.forEach(link => {
        if (link.dataset.shoppableHeroBound === 'true') return;
        link.dataset.shoppableHeroBound = 'true';

        var handle = link.dataset.productHandle;
        var productId = link.dataset.productId;

        if (!document.getElementById('QuickShopModal-' + productId)) return;

        // Capture-phase interceptor registered before modal binds its handler.
        // On mobile, blocks the modal handler so the link navigates normally.
        link.addEventListener('click', (event) => {
          if (theme.config.bpSmall) {
            event.stopImmediatePropagation();
            return;
          }
          const popover = event.target.closest('kit-popover');
          if (popover) popover.hidePopover?.();
        }, true);

        var hotspot = link.closest('.kit-shoppable-hero__hotspot');
        if (!hotspot) return;

        var preloadOnce = function() {
          if (link.dataset.shoppableHeroPreloaded === 'true') return;
          if (theme.config.bpSmall) return;

          // If a holder already exists from another section (e.g. product grid),
          // remove our duplicate modal shell to avoid duplicate IDs
          var holder = document.getElementById('QuickShopHolder-' + handle);
          if (holder && sectionEl) {
            var holderSection = holder.closest('[id^="shopify-section-"]');
            if (holderSection && holderSection !== sectionEl) {
              var duplicate = sectionEl.querySelector('#QuickShopModal-' + productId);
              if (duplicate) duplicate.remove();
            }
          }

          link.dataset.shoppableHeroPreloaded = 'true';
          link.classList.add('js-modal-open-quick-modal-' + productId);
          theme.preloadProductModal(handle, productId, link);

          hotspot.removeEventListener('mouseover', preloadOnce);
          hotspot.removeEventListener('focusin', preloadOnce);
        };

        hotspot.addEventListener('mouseover', preloadOnce);
        hotspot.addEventListener('focusin', preloadOnce);
      });
    }
  }

  customElements.define('kit-shoppable-hero', KitShoppableHero);

  } catch(e) { console.error(e); }
})();
})();
